module.exports = __webpack_public_path__ + "static/media/Khronos_RGB_June18.7bc828c2.png";